module.exports = __webpack_public_path__ + "img/bo.2afb6cc1.svg";